<template>
  <div class="layout-main">
      <Card :dis-hover="true">
        <div class="search-panel">
          <ul class="list-group">
           <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
            <li style="display: none;" class="list-group-item">
              <div class="item-label">搜索: </div>
              <Input v-model="searchval" style="width: 500px" >
                      <Select v-model="searchfield" slot="prepend" style="width: 80px">
                          <Option value="name">分组名</Option>
                      </Select>
                      <Button @click="request" slot="append" icon="ios-search"></Button>
                  </Input>
             
            </li>
          </ul>
        </div>
        <Divider style="margin: 0px;" dashed />
        <div style="padding: 10px 0px;" class="tools">
        </div>
        <Table :loading="loading" :columns="columns" :data="data" height="400">
          <template slot-scope="{ row }" slot="deal">
            <Select @on-change="(val)=>updateStatus(val, row.id)" v-model="row.last_sender_identity" style="width:200px">
              <Option v-for="item in statuses" :value="item.value" :disabled="item.disabled" :key="item.value">{{ item.name }}</Option>
            </Select>
          </template>
          <template slot-scope="{ row }" slot="store">
              <strong>{{ row.store.name }}</strong>
          </template>    
          <template slot-scope="{ row }" slot="action">
            <Icon style="cursor: pointer;" size="20" title="打开聊天" @click="openSession(row)" type="md-ionitron" />
          </template>
          
        </Table>
        <div class="page-wrap">            
          <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
        </div>
      </Card>
       
  </div>
</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";

export default {
  
  data() {
    return {
      loading: false,
      groupAddModal: false,
      groupEditModal: false,
      groupMsgModel: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      filter: {
        name: '',
        connector: 'lazada',
        csr_id: 0
      },
      groupAddForm: {
        name: ''
      },
      groupMsgForm: {
        id: 0,
        content: ''
      },
      groupEditForm: {
        id: 0,
        name: ''
      },
      statuses: [
        {name: '待处理', value: 1, active: true, disabled: false},
        {name: '已处理', value: 0, active: false, disabled: false},
      ],
      columns: [
          {
              title: '店铺',
              slot: 'store'
          },
          {
              title: '买家',
              key: 'title'
          },
          {
              title: '最近消息',
              key: 'summary'
          },
          {
              title: '最近发送时间',
              key: 'last_message_time_text'
          },
          {
              title: '是否解决',
              slot: 'deal'
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },

  methods: {
    selectitem (key, value) {
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.curPage = 1;
      this.pageSize = size;
      this.request();
    },
    buildparams () {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("limit", this.pageSize );
      param.set("csr_id", this.filter.csr_id);
      param.set("name", this.filter.name);
      if (this.searchval) {
        param.set(this.searchfield, this.searchval);
      }
      
      return param;
    },
    // 遗漏会话列表
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.forgetReply(this.filter.connector), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        self.loading = false;
      })
    },
    addGroup() {
      let param = new FormData();
      param.set("name", this.groupAddForm.name );
      RequestUtils.request(conf.addSessionGroup(), param)
      .then(() => {            
        this.groupAddForm.name = '';
        this.groupAddModal = false;
        this.request();
      })
    },
    editGroup() {
      let param = new FormData();
      param.set("id", this.groupEditForm.id );
      param.set("name", this.groupEditForm.name );
      RequestUtils.request(conf.editSessionGroup(), param)
      .then(() => {            
        this.groupEditForm.name = '';
        this.groupEditModal = false;
        this.request();
      })
    },
    groupEditModalShow(row) {
      this.groupEditModal = true;

      this.groupEditForm.id = row.id;
      this.groupEditForm.name = row.name;
    },
    delGroup(row) {
      
      this.$Modal.confirm({
          title: '删除',
          content: '<p>确定删除该记录吗?</p>',
          onOk: () => {

            let param = new FormData();
            param.set("id", row.id );

            RequestUtils.request(conf.delSessionGroup(), param)
            .then(() => {            
                this.$Message.info('操作成功!');
                this.request();
            })
          },
          onCancel: () => {
          }
      });
    },
    groupMsgModelShow(row) {
      this.groupMsgModel = true;
      this.groupMsgForm.id = row.id;

    },
    groupMsgSend() {
      let param = new FormData();
      param.set("group_id", this.groupMsgForm.id );
      param.set("content", this.groupMsgForm.content );
      
      this.groupMsgModel = false;
      RequestUtils.request(conf.groupMsgSend(), param)
      .then(() => {            
        this.request();
      })
    },
    // 打开会话
    openSession(row) {
      this.$router.push("/chat/main");
      this.$store.commit(this.filter.connector+"/openSession", {
        buyer_id: row.buyer_id,
        store_id: row.store_id
      });
    },
    // 修改处理状态
    updateStatus(value, id) {
      let self = this;
      let param = new FormData();
      param.set("id", id );
      param.set('status', value );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.updateReplyStatus(this.filter.connector), param)
      .then(() => {            
        self.request();
      })
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      margin-top: 4rem;
      padding: 1rem;
      
    }
  }

  
}
</style>
